import { useState, useCallback } from 'react';

const parsedValue = (value, type) => {
  switch (type) {
    case 'string':
      return String(value);
    case 'number':
      return parseInt(value, 10);
    case 'boolean':
      return value === 'true';
    default:
      return value;
  }
};

const useForm = (initialFields = {}) => {
  const [fields, updateField] = useState(initialFields);

  const resetField = useCallback((field, value) => {
    updateField(prev => ({
      ...prev,
      [field]: typeof value === 'function' ? value(prev[field]) : value,
    }));
  }, []);

  const resetFields = useCallback(newFields => {
    updateField(prev => ({
      ...prev,
      ...(typeof newFields === 'function' ? newFields(prev) : newFields),
    }));
  }, []);

  const handleChange = useCallback(event => {
    const { name, type, checked, dataset } = event.currentTarget;
    const value = parsedValue(
      event.currentTarget.value,
      dataset ? dataset.type : null
    );
    const sanitizedName = name.replace('[]', '');

    switch (type) {
      case 'radio': {
        updateField(prev => ({ ...prev, [name]: value }));

        break;
      }

      case 'checkbox': {
        if (name !== sanitizedName) {
          if (checked) {
            updateField(prev => ({
              ...prev,
              [sanitizedName]: [...prev[sanitizedName], value],
            }));
          } else {
            updateField(prev => ({
              ...prev,
              [sanitizedName]: prev[sanitizedName].filter(
                item => item.toString() !== value.toString()
              ),
            }));
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (checked) {
            updateField(prev => ({ ...prev, [name]: value }));
          } else {
            updateField(prev => ({ ...prev, [name]: '' }));
          }
        }

        break;
      }

      default: {
        updateField(prev => ({ ...prev, [name]: value }));
      }
    }
  }, []);

  return {
    handleChange,
    resetField,
    resetFields,
    fields,
  };
};

export default useForm;
